import { makeStyles } from '@mui/styles';

export default makeStyles(() => ({
  checkbox: {
    zIndex: 0,
  },
}));
